import React, { Suspense, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import * as actionCreators from "../../../store/actions/BUAP/BUAP";
import axiosAPI from "../../../axios/BUAP/AuthToken";
import clearLocalStorage from "../../../Shared/clearLocalStorage";
import Spinner from "../../../components/UI/Spinner/Spinner";
import StudentInfoForAdviseeList from "../Advisor/AdviseeList/StudentInfoForAdviseeList";
import studentAxios from "../../../axios/BUAP/students";
import AdviseeList from "../Advisor/AdviseeList/AdviseeList";
import Paradigm from "../Student/Paradigm/Paradigm";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "white",
    color: "white",
  },
  paper: {
    margin: theme.spacing(7, 6),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    backgroundColor: "#1971c2",
    margin: theme.spacing(3, 0, 2),
  },
  signintext: {
    margin: theme.spacing(3, 0, 0),
  },
  txtcontent: {
    padding: theme.spacing(5),
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    background: "#1971c2",
    color: "white",
  },
  slang: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(8),
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    fontSize: "70px",
    color: "#1971c2",
  },
  [theme.breakpoints.down("xs")]: {
    txtcontent: {
      padding: 0,
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0,
      background: "none",
      display: "none",
    },
    slang: {
      padding: 0,
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0,
      background: "none",
      display: "none",
    },
    image: {
      display: "none",
    },
  },
}));

const Login = (props) => {
  const classes = useStyles();
  const [load, setLoad] = React.useState(false);
  const [view, setView] = useState(null);
  const login = async (pathname, params) => {
    setLoad(true);
    clearLocalStorage();
    await axiosAPI
      .get("authenticate_mybu", {
        withCredentials: true,
      })
      .then(
        (response) => {
          if (response.data == "") {
          }
          registerToken(response, pathname, params);
        },
        (error) => {},
      )
      .catch((error) => {
        console.log(error);
      });
  };

  const registerToken = (response, pathname, params) => {
    const token = `bearer ${response.data.token}`;
    localStorage.setItem("token", token);
    props.setusername(response.data.username);
    props.setname(response.data.firstName + " " + response.data.lastName);
    if (response.data.rank === 0) {
      localStorage.setItem("studentdegree", response.data.id);
      localStorage.setItem("stuno", response.data.username);
      props.setstudentdegree(response.data.id);
      props.setstuno(response.data.username);
    } else {
      localStorage.setItem("studentdegree", -1);
      localStorage.setItem("stuno", -1);
      props.setstudentdegree(-1);
      props.setstuno(-1);
    }
    localStorage.setItem("usertype", response.data.rank);
    localStorage.setItem("username", response.data.username);
    localStorage.setItem("facCode", response.data.id);
    localStorage.setItem(
      "name",
      response.data.firstName + " " + response.data.lastName,
    );
    props.setiduser(response.data.id);
    props.setusertype(response.data.rank);
    setLoad(false);
    redirectToPath(token, pathname, params);
  };

  const redirectToPath = async (token, pathname, params) => {
    if (pathname && token) {
      if (pathname === "advisee") {
        const stuno = params.get("stuno");
        props.setstuno(stuno);
        await studentAxios
          .get("StudentDegree/" + stuno, {
            headers: { Authorization: token },
          })
          .then((response) => {
            props.setstudentdegree(response.data);
            setView(<StudentInfoForAdviseeList studentno={stuno} />);
          });
      } else if (pathname === "adviseelist") {
        setView(<AdviseeList />);
      } else if (pathname === "paradigm") {
        setView(<Paradigm />);
      } else if (pathname === "signature") {
        const Signature = React.lazy(
          () => import("../../../components/BUAP/Teacher/Signature"),
        );
        setView(<Signature></Signature>);
      }
    } else {
      setView(<Spinner></Spinner>);
    }
  };

  useEffect(() => {
    const init = async () => {
      const urlObj = new URL(window.location.href);
      const params = new URLSearchParams(urlObj.search);
      const path = params.get("pathname");
      await login(path, params);
    };

    init();
  }, []);

  return (
    <Grid container component="main" className={classes.root}>
      <Grid item xs={12} sm={12} md={12}>
        {load ? (
          <Spinner></Spinner>
        ) : (
          <Suspense fallback={<Spinner />}>{view}</Suspense>
        )}
      </Grid>
    </Grid>
  );
};

//Redux
const mapDispatchToProps = (dispatch) => {
  return {
    setusertype: (e) => dispatch(actionCreators.setusertype(e)),
    setusername: (e) => dispatch(actionCreators.setusername(e)),
    setstudentdegree: (e) => dispatch(actionCreators.setstudentdegree(e)),
    setstuno: (e) => dispatch(actionCreators.setstudentno(e)),
    setiduser: (e) => dispatch(actionCreators.setiduser(e)),
    setname: (e) => dispatch(actionCreators.setname(e)),
  };
};

export default connect(null, mapDispatchToProps)(Login);
